import React, { useEffect, useState } from "react";
import { Row, Col, Card, Table, Button, Input, Modal, Typography, Tag, Space, Drawer, Form, Select, notification } from "antd";
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import { baseUrl } from "../../config";
const { confirm } = Modal; const { Search } = Input; const { Title } = Typography;
const { Item } = Form; const { Option } = Select;
function PopOccupationsList() {
  const [form] = Form.useForm();
  const [dataList, setDataList] = useState([]); const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); const [limit] = useState(10);
  const [search, setSearch] = useState(''); const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false); const [editId, setEditId] = useState(null); const [saving, setSaving] = useState(false);
  const authHeader = { Authorization: `Bearer ${localStorage.getItem('accessToken')}` };
  const fetchList = async (page = currentPage, searchVal = search) => {
    setLoading(true);
    try { const res = await axios.get(`${baseUrl}/pop-occupations`, { headers: authHeader, params: { page, limit, search: searchVal } });
      if (res.data.status) { setDataList(res.data.result.map((item, i) => ({ ...item, key: (page-1)*limit+i+1 }))); setTotalCount(res.data.totalCount); }
    } catch(e) { console.error(e); } finally { setLoading(false); }
  };
  useEffect(() => { fetchList(); }, [currentPage]);
  const openAdd = () => { form.resetFields(); form.setFieldsValue({ status: '1' }); setEditId(null); setDrawerOpen(true); };
  const openEdit = (r) => { form.setFieldsValue({ name: r.name, status: String(r.status) }); setEditId(r.id); setDrawerOpen(true); };
  const onSave = async (values) => {
    setSaving(true);
    try {
      if (editId) await axios.put(`${baseUrl}/pop-occupations/${editId}`, values, { headers: authHeader });
      else await axios.post(`${baseUrl}/pop-occupations`, values, { headers: authHeader });
      notification.success({ message: editId ? 'Updated successfully' : 'Added successfully' });
      setDrawerOpen(false); fetchList();
    } catch(e) { notification.error({ message: e.response?.data?.message || 'Error' }); } finally { setSaving(false); }
  };
  const handleDelete = (id) => confirm({
    title: 'Delete this record?', icon: <ExclamationCircleOutlined />, okText: 'Yes, Delete', okType: 'danger', cancelText: 'Cancel',
    onOk: async () => { try { await axios.delete(`${baseUrl}/pop-occupations/${id}`, { headers: authHeader }); notification.success({ message: 'Deleted' }); fetchList(); } catch(e){} }
  });
  const columns = [
    { title: '#', dataIndex: 'key', key: 'key', width: 60 },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Status', dataIndex: 'status', key: 'status', width: 90, render: s => <Tag color={String(s)==='1'?'green':'red'}>{String(s)==='1'?'Active':'Inactive'}</Tag> },
    { title: 'Actions', key: 'actions', fixed: 'right', width: 150,
      render: (_, record) => (
        <Space size={4}>
          <Button size="small" icon={<EditOutlined />} onClick={() => openEdit(record)} style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}>Edit</Button>
          <Button size="small" danger icon={<DeleteOutlined />} onClick={() => handleDelete(record.id)}>Delete</Button>
        </Space>
      )
    }
  ];
  return (
    <div className="tabled">
      <Row gutter={[24, 0]}><Col span={24}>
        <Card
          title={<span style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>Occupations List</span>}
          headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
          extra={
            <Button icon={<PlusOutlined />} onClick={openAdd} style={{ background: '#fff', borderColor: '#fff', color: '#7a0000', fontWeight: 600 }}>
              Add New
            </Button>
          }
        >
          <div style={{ marginBottom: 16 }}>
            <Search
              placeholder="Search..."
              onSearch={val => { setSearch(val); setCurrentPage(1); fetchList(1, val); }}
              allowClear
              style={{ width: 300 }}
              enterButton={<Button style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}>Search</Button>}
            />
          </div>
          <Table columns={columns} dataSource={dataList} loading={loading} pagination={{ current: currentPage, pageSize: limit, total: totalCount, onChange: p => setCurrentPage(p), showTotal: t => `Total ${t} records` }} scroll={{ x: 'max-content' }} size="small" />
        </Card>
      </Col></Row>
      <Drawer title={editId ? 'Edit Occupation' : 'Add Occupation'} width={420} open={drawerOpen} onClose={() => setDrawerOpen(false)} bodyStyle={{ paddingBottom: 80 }}
        footer={
          <Space>
            <Button onClick={() => form.submit()} loading={saving} style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}>Save</Button>
            <Button onClick={() => setDrawerOpen(false)}>Cancel</Button>
          </Space>
        }>
        <Form form={form} layout="vertical" onFinish={onSave}>
          <Item name="name" label="Name" rules={[{ required: true, message: 'Required' }]}><Input placeholder="Enter name" /></Item>
          <Item name="status" label="Status"><Select><Option value="1">Active</Option><Option value="0">Inactive</Option></Select></Item>
        </Form>
      </Drawer>
    </div>
  );
}
export default PopOccupationsList;
